import type { Locale } from '@/intl/types'
import type { Label } from '@/scopes/account/group-responsible/domain/types'

const ONE_DAY_IN_MS = 1000 * 60 * 60 * 24

export function getParticipantName(firstName: string, lastName: string): string {
  return `${firstName} ${lastName}`
}

export function getPeriod(startDate: string, endDate: string, locale: Locale = 'nl-NL'): string {
  const startDateObj = new Date(startDate)
  const endDateObj = new Date(endDate)

  if (Number.isNaN(startDateObj.getTime()) || Number.isNaN(endDateObj.getTime())) {
    return ''
  }

  const startDay = startDateObj.toLocaleDateString(locale, { day: 'numeric' })
  const endDay = endDateObj.toLocaleDateString(locale, { day: 'numeric' })
  const month = endDateObj.toLocaleDateString(locale, { month: 'long' })
  const year = endDateObj.toLocaleDateString(locale, { year: 'numeric' })

  return `${startDay} - ${endDay} ${month} ${year}`
}

// TODO: refactor, this is UI component logic, not mapper logic
export function getLabels(startDate?: string, endDate?: string): Label[] {
  if (!startDate || !endDate)
    return []

  const today = new Date(new Date().setHours(0, 0, 0, 0))
  const start = new Date(startDate)
  const end = new Date(endDate)

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()))
    return []

  if (start > today) {
    const daysLeft = Math.floor((start.getTime() - today.getTime()) / ONE_DAY_IN_MS)
    return [
      {
        text:
          daysLeft === 1
            ? 'group_responsible_label_one_day_left'
            : 'groups_responsible_label_days_left',
        type: 'brand',
        ...(daysLeft !== 1 ? { placeholders: { days: `${daysLeft}` } } : {}),
      },
    ]
  }

  if (end >= today) {
    return [
      {
        text: 'groups_responsible_label_during_trip',
        type: 'info',
      },
    ]
  }

  return []
}
